import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  userInfo: any;
  token: string | null;
  permissionsMap: Record<string, any>;
}

const initialState: AuthState = {
  isAuthenticated: false,
  userInfo: null,
  token: null,
  permissionsMap: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn: (state, action: PayloadAction<{ token: string; userInfo: AuthState['userInfo']; permissionsMap: Record<string, any> }>) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.userInfo = action.payload.userInfo;
      state.permissionsMap = action.payload.permissionsMap;
  },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.userInfo = null;
      state.permissionsMap = {};
    },
  },
});

export const { logIn, logout } = authSlice.actions;
export default authSlice.reducer;
